import * as React from "react";
import { type RouteProps } from "react-router";
import { PermissionRoute } from "../../Common/Routing/PermissionRoute";

const StockMore = React.lazy(() => import("./StockMore"));
const StocktakerList = React.lazy(() => import("./Stocktaker/StocktakerList"));
const StocktakerView = React.lazy(() => import("./Stocktaker/StocktakerView"));
const StocktakerApply = React.lazy(() => import("../Stocktakes/View/StocktakeView"));
const StockList = React.lazy(() => import("./StockList/StockList"));
const SupplierImport = React.lazy(() => import("./SupplierImport/SupplierImport"));
const CappedPricing = React.lazy(() => import("./CappedPricing/CappedPricing"));
const BulkPriceEdit = React.lazy(() => import("./BulkPriceEdit/BulkPriceEdit"));
const BuyingPeriods = React.lazy(() => import("./BuyingPeriods/BuyingPeriods"));

export default function StockMoreIndex(): Array<React.ReactElement<RouteProps>> {
    return [
        <PermissionRoute
            title="Stock Management More | Shopfront"
            permissions={[ "see_products" ]}
            path="/stock/more"
            key="stock-more"
            element={<StockMore />}
        />,
        <PermissionRoute
            title="External Stocktakes | Shopfront"
            permissions={[ "see_stocktake", "perform_stocktake" ]}
            path="/stock/stocktaker"
            key="stock-external-stocktakes"
            element={<StocktakerList />}
        />,
        <PermissionRoute
            title="View External Stocktake | Shopfront"
            permissions={[ "see_stocktake", "perform_stocktake" ]}
            path="/stock/stocktaker/:id"
            key="stock-external-stocktake"
            element={<StocktakerView />}
        />,
        <PermissionRoute
            title="Apply External Stocktake | Shopfront"
            permissions={[ "see_stocktake", "perform_stocktake" ]}
            path="/stock/stocktaker/:id/apply"
            key="apply-external-stocktake"
            element={<StocktakerApply />}
        />,
        <PermissionRoute
            title="Stock List | Shopfront"
            permissions={[ "edit_products" ]}
            path="/stock/list"
            key="stock-list"
            element={<StockList />}
        />,
        <PermissionRoute
            title="Supplier Import | Shopfront"
            permissions={[ "see_suppliers", "edit_products", "view_product" ]}
            path="/stock/supplier-import"
            key="supplier-import"
            element={<SupplierImport />}
        />,
        <PermissionRoute
            title="Capped Pricing | Shopfront"
            permissions={[ "see_products", "edit_products", "view_product" ]}
            path="/stock/capped-pricing"
            key="capped-pricing"
            element={<CappedPricing />}
        />,
        <PermissionRoute
            title="Bulk Price Edit | Shopfront"
            permissions={[ "see_products", "edit_products", "view_product" ]}
            path="/stock/prices"
            key="bulk-price-edit"
            element={<BulkPriceEdit />}
        />,
        <PermissionRoute
            title="Buying Periods | Shopfront"
            permissions={[ "see_products", "edit_products", "view_product", "stock_create_order", "stock_edit_order" ]}
            path="/stock/buying-periods"
            key="buying-periods"
            element={<BuyingPeriods />}
        />,
    ];
}
